import {Stack, StackProps} from '../Stack/Stack';

export type HStackProps = Omit<StackProps, 'direction'>;

/**
 * HStack - Horizontal stack component
 * Wrapper around Stack with direction="row"
 * @example
 * <HStack spacing={4}>
 *   <div>Item 1</div>
 *   <div>Item 2</div>
 * </HStack>
 */
export const HStack = (props: HStackProps) => <Stack {...props} direction="row" />;
